import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { PWAProvider } from "./components/common/PWAProvider";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <PWAProvider>
        <App />
      </PWAProvider>
    </BrowserRouter>
  </React.StrictMode>
);
